module.exports = __webpack_public_path__ + "static/map2-03ee3124671c13d1b05b19b971cf226e.svg";